module.exports = __webpack_public_path__ + "static/media/25587937_1703517509723433_9042516582689549398_o.d90102f6.jpg";